import { render, staticRenderFns } from "./MallProduct.vue?vue&type=template&id=22a6ae2b&scoped=true&"
import script from "./MallProduct.vue?vue&type=script&lang=js&"
export * from "./MallProduct.vue?vue&type=script&lang=js&"
import style0 from "./MallProduct.vue?vue&type=style&index=0&id=22a6ae2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a6ae2b",
  null
  
)

component.options.__file = "MallProduct.vue"
export default component.exports